var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa fa-circle",staticStyle:{"font-size":"7px"},style:({ 'color': _vm.statusColor(_vm.type) })})}
var staticRenderFns = []

export { render, staticRenderFns }